document.addEventListener("DOMContentLoaded", () => {
    AOS.init({
        startEvent: 'load',
        offset: 50,
        duration: 1000,
        once: true
    })

    const loader = document.querySelector('.pageloader')
    loader.classList.add('hide')

    const headerButton = document.querySelector('.header__button')
    const nav = document.querySelector('.nav')
    headerButton.addEventListener('click', () => {
        headerButton.classList.toggle('header__button--open')
        nav.classList.toggle('nav--open')
    })

    if ($('.master__typed').length) {
        $('.master__typed').each(function () {
            $(this).typed({
                strings: [$(this).data('text1'), $(this).data('text2'), $(this).data('text3')],
                loop: $(this).data('loop') ? $(this).data('loop') : false,
                backDelay: $(this).data('backdelay') ? $(this).data('backdelay') : 2000,
                typeSpeed: 10,
            });
        });
    }

    if (document.querySelector('.wpcf7-form')) {
        const select = document.querySelector('.wpcf7-form select')
        select.addEventListener('click', () => {
            select.classList.add('clicked')
            select.removeEventListener('click')
        })
        var option = select.querySelector('option')
        option.setAttribute('disabled', 1)
        option.innerHTML = 'Temat:*'
    }

    window.onscroll = function () { scrollFunction() };
    var body = document.body,
        html = document.documentElement;


    const loadingBar = document.querySelector('.loadingBar');

    var scrollFunction = () => {
        var height = Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);
        var scroll = document.documentElement.scrollTop
        loadingBar.style.width = scroll / (height - window.innerHeight) * 100 + '%'
    }
    if (document.querySelector('.portfolio')) {
        const portfolios = document.querySelectorAll('.portfolio__box');
        const modals = document.querySelectorAll('.portfolio__modal')
        const modalContainer = document.querySelector('.modals')
        const particles = document.querySelector('#particles-js')
        modals.forEach(modal => {
            modal.querySelector('.close').addEventListener('click', () => {
                modal.classList.remove('portfolio__modal--visible')
                modalContainer.classList.remove('modals--visible')
                particles.style.zIndex = "2";
            })
        })
        portfolios.forEach(portfolio => {
            portfolio.addEventListener('click', () => {
                var modal = document.querySelector('.portfolio__modal[portfolio-id="' + portfolio.getAttribute('portfolio-id') + '"]')
                modalContainer.classList.add('modals--visible')
                modal.classList.add('portfolio__modal--visible')
                particles.style.zIndex = "0";
            })
        });
        modalContainer.addEventListener('click', (e) => {
            if (modalContainer.classList.contains('modals--visible')) {
                if (e.path[0] == modalContainer) {
                    var current = document.querySelector('.portfolio__modal--visible')
                    current.classList.remove('portfolio__modal--visible')
                    modalContainer.classList.remove('modals--visible')
                    particles.style.zIndex = "2";
                }

            }
        })
        const next = modalContainer.querySelector('.modals__arrowNext')
        const prev = modalContainer.querySelector('.modals__arrowPrev')
        var changeModal = (direction) => {
            if (modalContainer.classList.contains('modals--visible')) {
                var current = document.querySelector('.portfolio__modal--visible')
                var modalsTab = Array.from(modals)
                var found = modalsTab.findIndex(element => element === current)
                current.classList.remove('portfolio__modal--visible')
                var newIndex = found + direction
                if (newIndex > modalsTab.length - 1) {
                    newIndex = 0;
                }
                if (newIndex < 0) {
                    newIndex = modalsTab.length - 1
                }
                modals[newIndex].classList.add('portfolio__modal--visible')
            }
        }

        next.addEventListener('click', () => {
            changeModal(1)
        })
        prev.addEventListener('click', () => {
            changeModal(-1)
        })
    }

    $('.steps__slider').slick({
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 4,
        autoplay: 1,
        autoplaySpeed: 20000,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    slidesToScroll: 1,
                    appendDots: '.steps__slider__dots',
                }
            }
        ]
    })
});